export var AUTHORIZATION = {
    ADMIN: "ADMIN",
    ACCESS: "ACCESS"
};

//# sourceMappingURL=authorization.js.map